import { CustomHeaders } from 'pkg/api/headers';
import * as legacySdk from 'pkg/core/sdk';

import * as sdk from 'core/sdk';

// Each app renders code that calls through the other's SDK (shared modules in the legacy app,
// legacy dialogs in the new one), so the token and the acting user go to both.

export function setApiToken(token: string): void {
	sdk.setToken(token);
	legacySdk.setToken(token);
}

export function setApiCurrentUser(userId: string): void {
	sdk.setDefaultRequestHeader(CustomHeaders.CurrentUserId, userId);
	legacySdk.setDefaultRequestHeader(CustomHeaders.CurrentUserId, userId);
}
